import styled from 'styled-components'
import { Collapse, Panel } from 'react-bootstrap'
import { parseHtml } from 'helpers/utils'
import FontAwesome from 'react-fontawesome'
import InternalLink from 'components/InternalLink'
import List from 'components/List'

const Container = styled.div`
  margin-top: 25px;
`

const SuggestedContent = ({
  faqs,
  tutorials,
  deviceId,
  expandedFaq,
  handleFaqClick,
  isFetching
}) => {
  if (isFetching) {
    return null
  }

  const faqList = faqs.map((item) => {
    const active = parseInt(item.pk, 10) === expandedFaq

    return (
      <li key={item.pk}>
        <a href="#" onClick={handleFaqClick.bind(this, parseInt(item.pk, 10))}>
          <span>{item.name}</span>
          <FontAwesome name={`chevron-${active ? 'down' : 'right'}`} />
        </a>

        <Collapse in={active}>
          <Panel>
            <div dangerouslySetInnerHTML={{ __html: parseHtml(item.val) }} />
          </Panel>
        </Collapse>
      </li>
    )
  })

  const tutorialList = tutorials.map((item) => (
    <li key={item.pk}>
      <InternalLink to={`/tutorial/${item.pk}?device=${deviceId}`}>
        {item.name}
      </InternalLink>
    </li>
  ))

  return (
    <Container>
      {faqs.length !== 0 && <List title="Suggested FAQs:">{faqList}</List>}

      {tutorials.length !== 0 && (
        <List title="Suggested Tutorials:">{tutorialList}</List>
      )}
    </Container>
  )
}

export default SuggestedContent
